import createSagaMiddleware from "@redux-saga/core";
import LogRocket from "logrocket";
import { applyMiddleware, createStore, compose } from "redux";
import { persistStore } from "redux-persist";
import { persistedReducer } from "./rootReducer";
import rootSaga from "./rootSaga";

const sagaMiddleware = createSagaMiddleware();
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      serialize: true
    })
  : compose;

const store = createStore(
  persistedReducer,
  composeEnhancer(
    applyMiddleware(sagaMiddleware),
    applyMiddleware(LogRocket.reduxMiddleware())
  )
);
sagaMiddleware.run(rootSaga);
export const persistor = persistStore(store);
export default store;
